module.exports = __webpack_public_path__ + "img/about大图1.bd328674.jpg";